import { render, staticRenderFns } from "./r-info-card.vue?vue&type=template&id=12f559de"
import script from "./r-info-card.vue?vue&type=script&lang=js"
export * from "./r-info-card.vue?vue&type=script&lang=js"
import style0 from "./r-info-card.vue?vue&type=style&index=0&id=12f559de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports